export default __webpack_public_path__ + "static/media/info-icon.8c45f43d.svg";